export default __webpack_public_path__ + "static/media/cloud-3.baacfd4d.webp";